/**
 * DR-Bridge — intercepta o Checkout do UpCart e redireciona para a White
 * que o DarkRouter tiver materializado no theme.liquid (DR_STATE).
 *
 * Vive FORA do bloco <!-- DarkRouter Script Start/End -->. Quando a pool
 * roda e o DarkRouter regenera o script (novo shopDomain + novo MAP_STANDARD),
 * este ficheiro não é tocado: no clique lê o DR_STATE atual do <script
 * data-dr-injected> e manda o carrinho para essa White.
 */
(function () {
  'use strict';
  if (window.__DR_BRIDGE_INSTALLED) return;
  window.__DR_BRIDGE_INSTALLED = true;

  var LOG = '[DR-Bridge]';

  var HOST_FIX = {
    'delurs.online': 'outletcabina.es',
    'delurt.store': 'outlet-cabina.es',
    'edelkofferwelt.de': 'outletcabina.es',
    'edelkofferhaus.de': 'outlet-cabina.es',
    'wwv336-zq.myshopify.com': 'outletcabina.es',
    'h19yvc-sy.myshopify.com': 'outlet-cabina.es',
    'delurtwo.shop': 'outletcabina.es'
  };
  var LIVE = { 'outletcabina.es': 1, 'outlet-cabina.es': 1 };

  function liveShop() {
    var s = window.RIMOW_ACTIVE_SHOP || window.RIMOW_FALLBACK_SHOP || 'outletcabina.es';
    s = String(s).replace(/^https?:\/\//, '').split('/')[0].toLowerCase();
    if (HOST_FIX[s]) s = HOST_FIX[s];
    return LIVE[s] ? s : 'outletcabina.es';
  }

  function readDrState() {
    var scripts = document.querySelectorAll('script[data-dr-injected="true"]');
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent || '';
      var shop = (t.match(/shopDomain:\s*'([^']+)'/) || [])[1];
      var mapRaw = (t.match(/MAP_STANDARD:\s*(\{[\s\S]*?\})/) || [])[1];
      var promoRaw = (t.match(/MAP_PROMO:\s*(\{[\s\S]*?\}|\[[^\]]*\])/) || [])[1];
      if (!shop || !mapRaw) continue;
      try {
        var promo = {};
        if (promoRaw && promoRaw.charAt(0) === '{') promo = JSON.parse(promoRaw);
        return {
          shopDomain: liveShop(),
          MAP_STANDARD: JSON.parse(mapRaw),
          MAP_PROMO: promo
        };
      } catch (e) {
        console.warn(LOG, 'DR_STATE parse failed', e);
      }
    }
    return { shopDomain: liveShop(), MAP_STANDARD: {}, MAP_PROMO: {} };
  }

  function mapVariantId(state, id) {
    if (!id) return null;
    id = String(id);
    if (state.MAP_PROMO && state.MAP_PROMO[id]) return state.MAP_PROMO[id];
    if (state.MAP_STANDARD && state.MAP_STANDARD[id]) return state.MAP_STANDARD[id];
    return null;
  }

  var ATTR_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'gclid', 'fbclid', 'ttclid', 'msclkid',
    'sck', 'xcod', 'src', 'utmify',
    'fbp', 'fbc'
  ];

  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function collectAttr() {
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem('dr_attr') || '{}'); } catch (e) {}
    try {
      var urlParams = new URLSearchParams(window.location.search);
      ATTR_KEYS.forEach(function (k) {
        var v = urlParams.get(k);
        if (v) stored[k] = v;
      });
      urlParams.forEach(function (v, k) {
        if (k.indexOf('utm_') === 0 && v) stored[k] = v;
      });
    } catch (e) {}
    var fbp = readCookie('_fbp');
    var fbc = readCookie('_fbc');
    if (fbp) stored.fbp = fbp;
    if (fbc) stored.fbc = fbc;
    if (stored.fbclid && !stored.fbc) {
      stored.fbc = 'fb.1.' + Date.now() + '.' + stored.fbclid;
    }
    try { localStorage.setItem('dr_attr', JSON.stringify(stored)); } catch (e) {}
    return stored;
  }

  function attrQuery() {
    var stored = collectAttr();
    var parts = [];
    Object.keys(stored).forEach(function (k) {
      if (!stored[k] || k.charAt(0) === '_') return;
      parts.push(k + '=' + encodeURIComponent(stored[k]));
      parts.push('attributes[' + k + ']=' + encodeURIComponent(stored[k]));
    });
    return parts.join('&');
  }

  function reallyStop(e) {
    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}
    try {
      var orig = Event.prototype._sfOrigStopImmediatePropagation;
      if (typeof orig === 'function') orig.call(e);
      else if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    } catch (_) {}
  }

  function fireUtmifyIc() {
    try {
      var lead = null;
      try { lead = JSON.parse(localStorage.getItem('lead') || 'null'); } catch (_) {}
      if (!lead || !lead.pixelId) {
        console.warn(LOG, 'utmify IC: sem sessao (pixel ainda nao gravou lead)');
        return;
      }
      var loc = window.location;
      var sourceUrl = (loc.protocol + '//' + loc.hostname + loc.pathname).replace(/\/+$/, '');
      fetch('https://tracking.utmify.com.br/tracking/v1/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'InitiateCheckout',
          lead: lead,
          event: { sourceUrl: sourceUrl, pageTitle: (document.title || '').trim() || null }
        }),
        keepalive: true
      }).then(function () {
        console.log(LOG, 'utmify IC enviado');
      }).catch(function (e) {
        console.warn(LOG, 'utmify IC falhou', e);
      });
    } catch (e) {
      console.warn(LOG, 'utmify IC', e);
    }
  }

  function processCartAndRedirect() {
    var state = readDrState();
    var shop = liveShop();
    var pool = window.RIMOW_POOL || {};
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          console.warn(LOG, 'carrinho vazio');
          return;
        }
        var items = [];
        var missed = [];
        cart.items.forEach(function (item) {
          var vid = String(item.variant_id);
          var dest = (pool[shop] && pool[shop][vid]) ? pool[shop][vid] : mapVariantId(state, item.variant_id);
          if (dest) items.push(dest + ':' + item.quantity);
          else missed.push(vid + ' ' + (item.sku || item.title || ''));
        });
        if (!items.length) {
          console.warn(LOG, 'nenhum variant mapeado na White', shop, missed);
          return;
        }
        if (missed.length) console.warn(LOG, 'itens sem mapa (omitidos):', missed);
        var cc = ((window.RIMOW_POOL_META && window.RIMOW_POOL_META.country) || 'ES').toUpperCase();
        if (!/^[A-Z]{2}$/.test(cc)) cc = 'ES';
        var url = 'https://' + shop + '/cart/' + items.join(',') + '?country=' + cc + '&localization[country]=' + cc;
        var qs = attrQuery();
        if (qs) url += '&' + qs;
        console.log(LOG, 'redirect →', url);
        fireUtmifyIc();
        window.location.replace(url);
      })
      .catch(function (err) { console.error(LOG, 'cart.js', err); });
  }

  function isCheckoutLikeText(el) {
    var t = (el.textContent || el.getAttribute && el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length > 48) return false;
    return /check\s*out|finalizar|pagar agora|secure checkout/i.test(t);
  }

  function classStr(el) {
    var c = el.className;
    if (!c) return '';
    if (typeof c === 'string') return c.toLowerCase();
    if (typeof c.baseVal === 'string') return c.baseVal.toLowerCase();
    return String(c).toLowerCase();
  }

  function isUpcartCheckout(el) {
    if (!el || !el.tagName) return false;
    try {
      if (el.matches && el.matches(
        '.upcart-checkout-button, .upcart-checkout-button-container, [data-upcart-checkout], ' +
        '[class*="upcart"][class*="heckout"], [class*="Footer__checkoutButton"], ' +
        'button[name="checkout"], a[href*="/checkout"], .checkout-button, [data-checkout-button]'
      )) return true;
    } catch (_) {}

    var cls = classStr(el);
    var upcartish = cls.indexOf('upcart') !== -1
      || cls.indexOf('checkoutbutton') !== -1
      || cls.indexOf('custombutton') !== -1;
    if (upcartish && isCheckoutLikeText(el)) return true;

    if (el.closest) {
      try {
        var host = el.closest('[class*="upcart"], #upcart, .cart-drawer, [data-cart-drawer], [data-upcart]');
        if (host && isCheckoutLikeText(el)) return true;
      } catch (_) {}
    }
    return false;
  }

  function handleClick(e) {
    var path = e.composedPath ? e.composedPath() : (e.path || [e.target]);
    for (var i = 0; i < path.length; i++) {
      if (isUpcartCheckout(path[i])) {
        reallyStop(e);
        console.log(LOG, 'checkout interceptado');
        processCartAndRedirect();
        return;
      }
    }
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('submit', function (e) {
    var action = (e.target && e.target.action) || '';
    if (action.indexOf('/checkout') !== -1) {
      reallyStop(e);
      processCartAndRedirect();
    }
  }, true);

  collectAttr();
  console.log(LOG, 'ativo — vai seguir a White materializada pelo DarkRouter');
})();
